/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CatEventResponseDto
 */
export interface CatEventResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof CatEventResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CatEventResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof CatEventResponseDto
     */
    catEventId: string;
    /**
     * 
     * @type {string}
     * @memberof CatEventResponseDto
     */
    eventName: string;
    /**
     * 
     * @type {Date}
     * @memberof CatEventResponseDto
     */
    fromDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CatEventResponseDto
     */
    toDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CatEventResponseDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof CatEventResponseDto
     */
    description?: string;
}

/**
 * Check if a given object implements the CatEventResponseDto interface.
 */
export function instanceOfCatEventResponseDto(value: object): value is CatEventResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('catEventId' in value) || value['catEventId'] === undefined) return false;
    if (!('eventName' in value) || value['eventName'] === undefined) return false;
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function CatEventResponseDtoFromJSON(json: any): CatEventResponseDto {
    return CatEventResponseDtoFromJSONTyped(json, false);
}

export function CatEventResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatEventResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'catEventId': json['catEventId'],
        'eventName': json['eventName'],
        'fromDate': (new Date(json['fromDate'])),
        'toDate': (new Date(json['toDate'])),
        'country': json['country'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CatEventResponseDtoToJSON(json: any): CatEventResponseDto {
    return CatEventResponseDtoToJSONTyped(json, false);
}

export function CatEventResponseDtoToJSONTyped(value?: CatEventResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'catEventId': value['catEventId'],
        'eventName': value['eventName'],
        'fromDate': ((value['fromDate']).toISOString()),
        'toDate': ((value['toDate']).toISOString()),
        'country': value['country'],
        'description': value['description'],
    };
}

